"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicContactMessageSchema = exports.contactMessageSchema = void 0;
const zod_1 = require("zod");
// Full DB row schema for ContactMessage
exports.contactMessageSchema = zod_1.z.object({
    id: zod_1.z.string().optional(),
    name: zod_1.z.string().min(1).max(255),
    email: zod_1.z.string().email().max(255),
    company: zod_1.z.string().max(255).default(""),
    phone: zod_1.z.string().max(50).default(""),
    subject: zod_1.z.string().min(1).max(500),
    message: zod_1.z.string().min(1),
    type: zod_1.z.enum(["talep", "sikayet", "oneri", "diger"]).default("talep"),
    read: zod_1.z.boolean().default(false),
});
// API verbatim public form schema (source of truth: apps/api/src/common/schemas.ts)
exports.publicContactMessageSchema = zod_1.z.object({
    name: zod_1.z.string().min(2).max(255),
    email: zod_1.z.string().email().max(255),
    company: zod_1.z.string().max(255).optional().default(""),
    phone: zod_1.z.string().max(50).optional().default(""),
    subject: zod_1.z.string().min(3).max(500),
    message: zod_1.z.string().min(10),
    type: zod_1.z.enum(["oneri", "sikayet", "talep", "itiraz"]).optional().default("talep"),
});
//# sourceMappingURL=contact-message.js.map